var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 348.077 348.077",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style860"
  }, "\r\n        .st0{fill:#717070}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m340.273 275.083-53.755-53.761c-10.707-10.664-28.438-10.34-39.518.744l-27.082 27.076a792.327 792.327 0 0 1-5.344-2.973c-17.102-9.476-40.509-22.464-65.14-47.113-24.704-24.701-37.704-48.144-47.209-65.257-1.003-1.813-1.964-3.561-2.913-5.221l18.176-18.149 8.936-8.947c11.097-11.1 11.403-28.826.721-39.521L73.39 8.194c-10.682-10.68-28.421-10.356-39.518.744l-15.15 15.237.414.411c-5.08 6.482-9.325 13.958-12.484 22.02C3.74 54.28 1.927 61.603 1.098 68.941-6 127.785 20.89 181.564 93.866 254.541c100.875 100.868 182.167 93.248 185.674 92.876 7.638-.913 14.958-2.738 22.397-5.627 7.992-3.122 15.463-7.361 21.941-12.43l.331.294 15.348-15.029c11.074-11.098 11.393-28.83.716-39.542z",
    id: "path862"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717070",
      fillOpacity: 1,
      strokeWidth: 1.47490251
    },
    d: "M263.27 346.504c-25.936-3.17-46.928-9.509-72.27-21.823-35.184-17.097-62.683-37.483-97.44-72.233-44.732-44.726-68.056-76.565-82.183-112.185-7.25-18.278-9.902-32.663-9.902-53.699 0-21.522 1.603-29.75 8.832-45.323 6.946-14.966 24.562-34.359 34.74-38.246 9.356-3.573 17.996-1.91 26.832 5.168 12.994 10.407 57.817 57.028 60.113 62.525 5.702 13.645 2.144 22.098-17.836 42.373L98.579 128.87l8.6 15.043c23.805 41.637 54.534 72.4 96.94 97.048l16.137 9.379 16.345-16.247c8.99-8.937 18.213-16.945 20.497-17.797 7.925-2.957 17.587-1.902 24.688 2.697 8.618 5.58 59.31 56.991 62.6 63.486 6.379 12.597 1.824 25.779-13.955 40.388-17.978 16.644-45.405 26.297-67.16 23.638z",
    id: "path871"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5c5da77bbb05da03a86f5ee095da4e63.svg";
export { ForwardRef as ReactComponent };